module.exports = __webpack_public_path__ + "static/media/comma.3ed4bc3f.svg";